import { render } from "./mcoupon.vue?vue&type=template&id=c98287d0&scoped=true"
const script = {}

import "./mcoupon.vue?vue&type=style&index=0&id=c98287d0&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98287d0"]])

export default __exports__